<template>
  <div
    class="setting-popup bg-laying-setting"
    v-show='boxData.judgeBox'
    :style="{
      'top': boxData.fix.y+'px',
      'left': boxData.fix.x+'px',
      'z-index': boxData.Zindex,
    }"
    @mousedown.stop="stopDocument($event);$bus.emit('windowMousedown_vue')"
  >
    <div class="setting-popup__drag-area"
      v-on:mousedown="moveStart($event, true)"
      v-on:mousemove="moveArea($event)"
      v-on:mouseup="saveMoveState($event)"
      :style="{'cursor': 'move'}"
    >
      背景铺设样式
    </div>
    <div class="setting-popup__content">
      <ul class="items">
        <li
          v-for="item in items" :key="item.type" class="item"
          @click="onClickItem(item)"
        >
          <div class="item__image" :class="{'is-selected': item.selected}">
            <i class="item__icon" :class="{[`icon-laying-${item.type}`]: true}"></i>
          </div>
          <div class="item__text">{{item.text}}</div>
        </li>
      </ul>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import popup from '../mixins/popup';

export default {
  mixins: [popup],
  data () {
    return {
      // popupType: 'bgLayingSetting',
      popupType: 'layingSetting.bg',
      items: [
        {type: 'fit', text: '适应', selected: false},
        {type: 'fill', text: '填充', selected: false},
        {type: 'stretch', text: '拉伸', selected: false},
        {type: 'tile', text: '平铺', selected: false},
      ],
      currLaying: '',
      scene: ''
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
      'Tool_Size',
    ])
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.scene = this.SelectScenes_Msg;
          let bgProps = this.SelectScenes_Msg.background.data;

          this.setSelected({type: bgProps.laying});
        }
      }
    },
    'Tool_Size': {
      handler (val) {
        let scene = this.TOOL.selectedScenes;
        if (!scene) {
          return;
        }
        if (scene.background.data.laying === 'tile') {
          scene.setBgLaying('tile');
        }
      },
      deep: true
    },
    'TOOL.optimized': {
      handler (val) {
        this.updateLaying();
      }
    },
    SelectScenes_Msg: {
      handler () {
        this.updateLaying();
        // 通知左侧栏
        this.$bus.emit('bgSetting.updateLeftSide');
      }
    }
  },
  created () {
    eve.on('setBgLaying', (scene) => {
      let bgProps = scene.background.data;
      this.setSelected({type: bgProps.laying});
      this.$bus.emit('bgLayingSetting.updateLaying');
    });
  },
  methods: {
    setSelected ({type = 'fill'} = {}) {
      this.currLaying = type;
      this.items.map(item => {
        this.$set(item, 'selected', type === item.type);
      });
    },
    onClickItem ({
      type
    } = {}) {
      let item = (this.items.filter(v => v.selected) || [])[0];
      if (type === item.type) {
        return;
      }
      this.scene.setBgLaying(type, true)
        // .then((scene) => {
        //   let bgProps = scene.background.data;
        //   this.setSelected({type: bgProps.laying});
        //   this.$bus.emit('bgLayingSetting.updateLaying');
        // })
    },
    updateLaying () {
      return;
      if (!(this.SelectScenes_Msg || {}).background) {
        return;
      }
      let bgProps = this.SelectScenes_Msg.background.data;
      if (bgProps.type !== 'Image') {
        return;
      }
      this.setSelected({type: bgProps.laying});

      let item = (this.items.filter(v => v.selected) || [])[0];
      if (!item) {
        return;
      }
      this.SelectScenes_Msg.setBgLaying(item.type, false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors.scss";
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  max-height: 562px;
  z-index: 35;
  border-radius: 6px 6px 3px 3px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 20px 0 20px;
  }
}

.items {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.item {
  cursor: pointer;
  &:hover & {
    &__image {
      background-color: #d8d8e9;
    }
  }

  &__image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 58px;
    background-color: #f0f0f8;
    border-radius: 4px;

    &.is-selected {
      border: solid 2px #617cf2;
    }
  }

  &__text {
    margin-top: 0.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/bgLayingSetting.vue